import React, { useState, useContext, useEffect } from 'react';
import '../../Booking.css';
import { StateContext } from '../../../../StateProvider';
import { FaInfoCircle } from 'react-icons/fa';
import { tooltips } from './shuttleTooltips';
import ShuttleOptions from './ShuttleOptions';
import { Carousel as BootstrapCarousel } from 'react-bootstrap';

import hotelIcon from './../../../../../assets/Landing/hotelIcon.png';
import airportIcon from './../../../../../assets/Landing/shuttleIcon.png';
import daycareIcon from './../../../../../assets/Landing/daycareIcon.png';
import trainingIcon from './../../../../../assets/Landing/trainingIcon.png';
import groomingIcon from './../../../../../assets/Landing/groomingIcon.png';
import adventureIcon from './../../../../../assets/Landing/adventureIcon.png';

import shuttleBanner1 from '../../../../../assets/Store/Services/Daycare/shuttleBanner1.png';
import shuttleBanner2 from '../../../../../assets/Store/Services/Daycare/shuttleBanner2.png';
import shuttleBanner3 from '../../../../../assets/Store/Services/Daycare/shuttleBanner3.png';

function ShuttleBooking() {
    const { user, startBookingSession, updateBookingInfo } = useContext(StateContext);

    const [selectedPetForShuttle, setSelectedPetForShuttle] = useState(null);
    const [selectedService, setSelectedService] = useState(null);
    const [isShuttleOptionsOpen, setIsShuttleOptionsOpen] = useState(false);

    const [tooltipVisibility, setTooltipVisibility] = useState({
        ride: false,
        petSelection: false,
        appointmentDate: false,
        emergencyContact: false,
        specialRequests: false
    });

    const [shuttleBookingData, setShuttleBookingData] = useState({
        shuttleType: '',
        selectedPets: [],
        dateRange: null,
        selectedTimeSlot: '',
        pickUpLocation: '',
        dropOffLocation: '',
        emergencyContactName: '',
        emergencyContactNumber: '',
        specialNotes: ''
    });

    const serviceIcons = {
        Airport: airportIcon,
        Daycare: daycareIcon,
        Hotel: hotelIcon,
        Grooming: groomingIcon,
        Training: trainingIcon,
        Adventure: adventureIcon
    };

    useEffect(function () {
        startBookingSession('store/services/shuttle', {});
    }, [startBookingSession]);

    useEffect(function () {
        updateBookingInfo('store/services/shuttle', shuttleBookingData);
    }, [shuttleBookingData, updateBookingInfo]);

    const showTooltip = function (key) {
        setTooltipVisibility(function (prev) {
            return {
                ...prev,
                [key]: true
            };
        });
    };

    const hideTooltip = function (key) {
        setTooltipVisibility(function (prev) {
            return {
                ...prev,
                [key]: false
            };
        });
    };

    const handleServiceSelection = function (service) {
        setSelectedService(service);
        setSelectedPetForShuttle(null);
        setIsShuttleOptionsOpen(true);

        setShuttleBookingData(function (prevData) {
            return {
                shuttleType: service,
                selectedPets: [],
                dateRange: null,
                selectedTimeSlot: '',
                pickUpLocation: '',
                dropOffLocation: '',
                emergencyContactName: prevData && prevData.emergencyContactName ? prevData.emergencyContactName : '',
                emergencyContactNumber: prevData && prevData.emergencyContactNumber ? prevData.emergencyContactNumber : '',
                specialNotes: prevData && prevData.specialNotes ? prevData.specialNotes : ''
            };
        });
    };

    const handleOptionSelect = function (field, value) {
        setShuttleBookingData(function (prevData) {
            return {
                ...prevData,
                [field]: value
            };
        });
    };

    return (
        <div className='booking-backdrop'>
            <section className="store-banner-section">
                <BootstrapCarousel fade controls={false} indicators={false} interval={3000}>
                    <BootstrapCarousel.Item>
                        <img className="d-block w-100" src={shuttleBanner1} alt="Hero 1" />
                    </BootstrapCarousel.Item>
                    <BootstrapCarousel.Item>
                        <img className="d-block w-100" src={shuttleBanner2} alt="Hero 2" />
                    </BootstrapCarousel.Item>
                    <BootstrapCarousel.Item>
                        <img className="d-block w-100" src={shuttleBanner3} alt="Hero 3" />
                    </BootstrapCarousel.Item>
                </BootstrapCarousel>
            </section>

            <div className="booking-container">
                <div className="booking-header">
                    <h3>Pawsible Shuttle</h3>
                </div>

                <div className="booking-content">
                    <div className="booking-section">
                        <h2>
                            Choose Service <FaInfoCircle onMouseOver={() => showTooltip('ride')} onMouseOut={() => hideTooltip('ride')} />
                        </h2>
                        {tooltipVisibility.ride && <div className="tooltip" dangerouslySetInnerHTML={{ __html: tooltips.ride }}></div>}

                        <div className="service-selection">
                            {['Airport', 'Daycare', 'Hotel', 'Training', 'Grooming', 'Adventure'].map(function (service) {
                                return (
                                    <button
                                        key={service}
                                        className={`shuttle-service-button-${selectedService === service ? 'selected' : ''}`}
                                        onClick={() => handleServiceSelection(service)}
                                    >
                                        <img src={serviceIcons[service]} alt={`${service} Icon`} className="service-icon" />
                                        {service}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <div className={`booking-section-selectedPetForShuttle ${isShuttleOptionsOpen ? 'open' : 'close'}`}>
                        {selectedService && (
                            <div>
                                <ShuttleOptions
                                    user={user}
                                    selectedService={selectedService}
                                    selectedPetForShuttle={selectedPetForShuttle}
                                    setSelectedPetForShuttle={setSelectedPetForShuttle}
                                    shuttleBookingData={shuttleBookingData}
                                    setShuttleBookingData={setShuttleBookingData}
                                />
                            </div>
                        )}
                    </div>

                    {/* Emergency Contact */}
                    <div className="booking-section">
                        <h2>Emergency Contact <FaInfoCircle onMouseOver={() => showTooltip('emergencyContact')} onMouseOut={() => hideTooltip('emergencyContact')} /></h2>
                        {tooltipVisibility.emergencyContact && <div className="tooltip" dangerouslySetInnerHTML={{ __html: tooltips.emergencyContact }}></div>}
                        <div className="input-field">
                            <input 
                                type="name" 
                                id="emergencyContactName" 
                                placeholder="Name" 
                                onChange={(e) => handleOptionSelect('emergencyContactName', e.target.value)}
                            />
                            <input 
                                type="tel" 
                                id="emergencyContactNumber" 
                                placeholder="Phone" 
                                onChange={(e) => handleOptionSelect('emergencyContactNumber', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="booking-section">
                        <h2>
                            Special Requests <FaInfoCircle onMouseOver={() => showTooltip('specialRequests')} onMouseOut={() => hideTooltip('specialRequests')} />
                        </h2>
                        {tooltipVisibility.specialRequests && <div className="tooltip" dangerouslySetInnerHTML={{ __html: tooltips.specialRequests }}></div>}

                        <textarea
                            placeholder=""
                            value={shuttleBookingData.specialNotes}
                            onChange={(e) => handleOptionSelect('specialNotes', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShuttleBooking;